import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { Container, Button, Grid, Input, Icon, Dropdown, Form, Step, Segment, Table, Message, DropdownItemProps, Checkbox, Loader, Select } from 'semantic-ui-react';
import Globals from "../Globals";
import { v4 as uuidv4 } from 'uuid';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import StripeApi from '../api/StripeApi';
import IVisitSlot from '../Models/IVisitSlot';
import OpeningHoursApi from '../api/OpeningHoursApi';
import IBookedVisitSlot from '../Models/IBookedVisitSlot';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc' // import utc module
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/fr'; // import locale

dayjs.locale('fr') ;
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Europe/Paris');

const ReservationVisite: React.FC = () => {
  const currentAction = document.location.hash && document.location.hash.indexOf('?action=') > 0 ? document.location.hash.split('?action=').pop() : null;
  let initStep = 1;
  let bookingId = undefined;
  if (currentAction){
    if (currentAction.indexOf("payment_success") === 0) {
        initStep = 4;
        let idxBookingId = document.location.hash.indexOf('&id=');
        if (idxBookingId > 0) bookingId = document.location.hash.substr(idxBookingId + 4);
    }
    else if (currentAction.indexOf("cancel") === 0) {
      initStep = 5;
    }
  }

  const defaultValuesLocalhost = {
    nbEntrancesFamilyHNLG: 0,
    nbEntrancesFamilyNLG: 0,
    nbEntrancesIndividualHNLG: 0,
    nbEntrancesIndividualNLG: 0,
    nbEntrancesFree: 0,
    zipCode: '93160',
    firstName: 'Gaetan',
    lastName: 'TEST',
    email: 'test@fermerainbow.com'
  };

  const referrerOptions = [
    { key: "fb", text: "Facebook", value: "Facebook" },
    { key: "gs", text: "Recherche Internet", value: "Recherche" },
    { key: "bo", text: "Bouche à oreille", value: "Bouche à oreille" },
    { key: "ta", text: "TripAdvisor", value: "TripAdvisor" },
    { key: "gm", text: "Google Maps", value: "Google Maps" },
    { key: "au", text: "Autre moyen", value: "Autre" },
  ];

  const [step, setStep] = useState<number>(initStep);
  const [selectedDate, setSelectedDate] = useState<string>();
  const [selectedTime, setSelectedTime] = useState<string>();
  const [nbEntrancesIndividualNLG, setNbEntrancesIndividualNLG] = useState<number>(document.location.hostname === 'localhost' ? defaultValuesLocalhost.nbEntrancesIndividualNLG : 0);
  const [nbEntrancesFamilyNLG, setNbEntrancesFamilyNLG] = useState<number>(document.location.hostname === 'localhost' ? defaultValuesLocalhost.nbEntrancesFamilyNLG : 0);
  const [nbEntrancesIndividualHNLG, setNbEntrancesIndividualHNLG] = useState<number>(document.location.hostname === 'localhost' ? defaultValuesLocalhost.nbEntrancesIndividualHNLG : 0);
  const [nbEntrancesFamilyHNLG, setNbEntrancesFamilyHNLG] = useState<number>(document.location.hostname === 'localhost' ? defaultValuesLocalhost.nbEntrancesFamilyHNLG : 0);
  const [nbEntrancesFree, setNbEntrancesFree] = useState<number>(document.location.hostname === 'localhost' ? defaultValuesLocalhost.nbEntrancesFree : 0);
  const [zipCode, setZipCode] = useState<string>(document.location.hostname === 'localhost' ? defaultValuesLocalhost.zipCode : '');
  const [firstName, setFirstName] = useState<string>(document.location.hostname === 'localhost' ? defaultValuesLocalhost.firstName : '');
  const [lastName, setLastName] = useState<string>(document.location.hostname === 'localhost' ? defaultValuesLocalhost.lastName : '');
  const [email, setEmail] = useState<string>(document.location.hostname === 'localhost' ? defaultValuesLocalhost.email : '');
  const emailIsValid = useMemo<boolean>(() => {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
  }, [email]);
  const [verificationEmail, setVerificationEmail] = useState<string>(document.location.hostname === 'localhost' ? defaultValuesLocalhost.email : '');
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const [isFirstVisit, setIsFirstVisit] = useState<boolean>(true);
  const [referrer, setReferrer] = useState<string>('');
  const [otherReferrer, setOtherReferrer] = useState<string>();
  const [stripe, setStripe] = useState<Stripe | null>();
  const [step2IsValid, setStep2IsValid] = useState<boolean>(false);
  const [proceedingToPayment, setProceedingToPayment] = useState<boolean>(false);
  const [displayEmailError, setDisplayEmailError] = useState<boolean>(false);  
  const [displayVerificationEmailError, setDisplayVerificationEmailError] = useState<boolean>(false);
  const [displayZipCodeError, setDisplayZipCodeError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [visitDayOptions, setVisitDaysOptions] = useState<DropdownItemProps[]>([]);
  const [visitHourOptions, setVisitHourOptions] = useState<DropdownItemProps[]>([]);
  const [visitSlots, setVisitSlots] = useState<IVisitSlot[]>();
  const [visitsPerSlot, setVisitsPerSlot] = useState<IBookedVisitSlot[]>();
  const [validatedCGV, setValidatedCGV] = useState<boolean>(false);
  const [curDate] = useState<Date>(new Date());

  const executeScroll = () => {
    const elt = document.getElementById('reservation-visite');
    if (elt) elt.scrollIntoView();
  }

  const stepTitle = useMemo(() => {
    switch(step){
      case 1:
        return "Vos billets";
      case 2:
        return "Vos coordonnées";
      case 3:
        return "Récapitulatif de la commande";
      case 4:
        return "Commande validée";
      case 5: 
        return "Commande annulée";
    }
  }, [step]);

  useEffect(() => {
    if (!stripe) {
      const stripeApi = new StripeApi();
      stripeApi.getPublicKey().then((res) => {
        loadStripe(res.data)
          .then((res) => {
            setStripe(res);
          });
      });
    }
  }, [stripe]);

  useEffect(() => {
    const daysOfWeek = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
    const monthsOfYear = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
      if (!visitSlots && curDate) {
      const opHoursApi = new OpeningHoursApi();
      Promise.all([opHoursApi.getBookingOpeningHours(), opHoursApi.getBookedVisits()])
      .then(([res, res2]) => {
        setVisitsPerSlot(res2.data);

        let visDays: DropdownItemProps[] = [];
        res.data.forEach(r => {
          const day = new Date(r.date);
          
          const year = day.getFullYear().toString();
          const month = day.getMonth() + 1;
          const paddedMonth = (month < 10) ? `0${month}` : month.toString();
          const curday = day.getDate();
          const paddedDay = (curday < 10) ? `0${curday}` : curday.toString();

          const vDate = dayjs(r.date).hour(r.endHour).toDate();
        
          const newValue = { 
            text:  `${daysOfWeek[day.getDay()]} ${paddedDay} ${monthsOfYear[month-1]} ${year}`,
            value: `${year}/${paddedMonth}/${paddedDay}`,
            key: r.date.substr(0, 10),
            disabled: vDate < curDate,
          } as DropdownItemProps;

          const existingIdx = visDays.findIndex((d) => d.value === newValue.value);
          if (existingIdx < 0) 
            visDays.push(newValue);
          else {
            if (!newValue.disabled) // update if valid
              visDays[existingIdx] = newValue;
          }
        });
        setVisitDaysOptions(visDays);
        setVisitSlots(res.data);
      });
    }
  }, [curDate, visitSlots]);

  const visitIsFull = useCallback((visit: IVisitSlot, date: string) => {
    let curBooked = 0;
    if (visitsPerSlot) {
      const cb = visitsPerSlot.find(v => v.eventDate === `${date}`);
      if (cb) curBooked = cb.booked;
    }
    return (curBooked > (visit.quota ? visit.quota : Globals.MaxPersonsPerSlot));
  }, [visitsPerSlot]);

  useEffect(() => {
    if (lastName && firstName && zipCode && zipCode.trim().length === 5 && emailIsValid && verificationEmail === email) {
      return setStep2IsValid(true);
    }
    else {
      return setStep2IsValid(false);
    }
  }, [lastName, firstName, zipCode, email, verificationEmail, emailIsValid]);

  const totalAmount = useMemo<number>(() => {
    return (nbEntrancesFamilyNLG * Globals.TarifFamilleNLG) + (nbEntrancesIndividualNLG * Globals.TarifIndividuelNLG) + (nbEntrancesFamilyHNLG * Globals.TarifFamilleHNLG) + (nbEntrancesIndividualHNLG * Globals.TarifIndividuelHNLG);
  }, [nbEntrancesIndividualNLG, nbEntrancesIndividualHNLG, nbEntrancesFamilyNLG, nbEntrancesFamilyHNLG]);

  useEffect(() => {
    let visHours: DropdownItemProps[] = [];
    if (curDate && selectedDate && visitDayOptions && visitSlots) 
    {
      const selectedDateKey = visitDayOptions.find(v => v.value === selectedDate);
      
      if (selectedDateKey){
        const initialDate = visitSlots.filter(v => v.date.indexOf(selectedDateKey.key) === 0);
        if (initialDate && initialDate.length > 0){
          initialDate.forEach((d) => {
            for(let idx = d.startHour; idx < d.endHour; idx++) {
              const date = `${d.date.split('T')[0]}T${idx}:00:00`;
              const isFull = visitIsFull(d, date);
              const selectableDateTime = dayjs.tz(date, 'Europe/Paris').toDate();

              visHours.push({
                key: `${idx}:00`,
                text: `${idx}h${(isFull ? " (complet)" : "")}${(curDate > selectableDateTime) ? " (fini)" : ""}`,
                value: selectableDateTime.toISOString(),
                disabled: (isFull || curDate > selectableDateTime),
              });
            }
          });
        }
      }
    }
    setVisitHourOptions(visHours);
  }, [curDate, selectedDate, visitDayOptions, visitSlots, visitsPerSlot, visitIsFull]);
  
  const nbEntrancesIndividualOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((idx) => { return { key: idx, value: idx, text: idx } as DropdownItemProps });
  const nbEntrancesFreeOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((idx) => { return { key: idx, value: idx, text: idx } as DropdownItemProps });
  const nbEntrancesFamilyOptions = [0, 1, 2, 3, 4, 5].map((idx) => { return { key: idx, value: idx, text: idx } as DropdownItemProps });

  const proceedToPayment = async (ev: any) => {
    // Block native form submission.
    ev.preventDefault();

    setProceedingToPayment(true);
    if (!stripe  || !selectedTime) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }

    // Create a new Checkout Session using the server-side endpoint
    const stripeApi = new StripeApi();
    stripeApi.createVisitSession({
        Id: uuidv4(),
        Lastname: lastName,
        FirstName: firstName,
        Email: email,
        Phone: phoneNumber,
        ZipCode: zipCode,
        EventDate: new Date(selectedTime),
        IndividualNLG: nbEntrancesIndividualNLG,
        IndividualHNLG: nbEntrancesIndividualHNLG,
        FamilyNLG: nbEntrancesFamilyNLG,
        FamilyHNLG: nbEntrancesFamilyHNLG,
        Free: nbEntrancesFree,
        Option1: 0,
        Option2: 0,
        Option3: 0,
        Option4: 0,
        Option5: 0,
        FirstVisit: isFirstVisit,
        Referrer: referrer === 'Autre' && otherReferrer ? otherReferrer : referrer
    })
    .then((session) => {
        return stripe.redirectToCheckout({ sessionId: session.data.id });
      })
    .then(function (result) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, you should display the localized error message to your
      // customer using `error.message`.
      if (result.error) {
        setErrorMessage(result.error.message);
        setProceedingToPayment(false);
      }
    })
    .catch(function (error) {
      setErrorMessage(error.message)
      console.error('Error:', error.message);
      setProceedingToPayment(false);
    });
  };

  return (
    <Container fluid>
      <Form>
      { step <= 3 && (
      <Step.Group widths="three" size="tiny">
        <Step active={step === 1} icon="ticket" title="Billets" completed={step > 1} />
        <Step active={step === 2} icon="user" title="Coordonnées" completed={step > 2} />
        <Step active={step === 3} completed={step === 4} icon="payment" title="Paiement" />
      </Step.Group>
      )}
      <h4>{stepTitle}</h4>
      { !visitSlots && (
        <Segment textAlign='center'>
          <Loader active inline size='small' />
          Chargement du planning des réservations...
        </Segment>
      )}
      { visitSlots && step === 1 && (
        <React.Fragment>
        <Grid stackable>
          <Grid.Row columns="2">
            <Grid.Column><label>Date de la visite *</label>
              <Dropdown
                placeholder='Sélectionnez le jour de visite souhaité'
                fluid
                selection
                key="visitDayChoice"
                value={selectedDate}
                onChange={(e, data) => { setSelectedDate(data.value as string); setSelectedTime(''); }}
                options={visitDayOptions}
              />
            </Grid.Column>
            <Grid.Column>
              <label>Créneau horaire *</label>
              <Dropdown
                placeholder="Sélectionnez l'heure de visite souhaitée"
                fluid                
                selection
                key="visitHourChoice"
                value={selectedTime}
                onChange={(e, data) => { setSelectedTime(data.value as string); }}
                options={visitHourOptions}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Message>
                <Message.Header>Important</Message.Header>
                <p>Les entrées "Famille" correspondent à une entrée pour un groupe de 4 ou 5 personnes. Si vous êtes moins de 4, choisissez des entrées individuelles, sinon sélectionnez une entrée famille et éventuellement d'autres entrées si nécessaire.</p>
              </Message>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={8}>Entrée individuelle <b style={{ whiteSpace: 'nowrap'}}>Résident Noisy-Le-Grand *</b></Grid.Column>
            <Grid.Column width={5}>
              <Button onTouchEnd={(e:any) => { e.preventDefault(); setNbEntrancesIndividualNLG(nbEntrancesIndividualNLG - 1); }}  onClick={() => setNbEntrancesIndividualNLG(nbEntrancesIndividualNLG - 1)} disabled={nbEntrancesIndividualNLG <= 0} size="small"><Icon name="minus"></Icon></Button>
              <Dropdown
                selection
                compact
                key="individualEntrancesNLG"
                options={nbEntrancesIndividualOptions}
                value={nbEntrancesIndividualNLG}
                onChange={(ev, { value }) => { setNbEntrancesIndividualNLG(value as number) }} />
            &nbsp;
            <Button onTouchEnd={(e:any) => { e.preventDefault(); setNbEntrancesIndividualNLG(nbEntrancesIndividualNLG + 1); }} onClick={() => setNbEntrancesIndividualNLG(nbEntrancesIndividualNLG + 1)} disabled={nbEntrancesIndividualNLG >= 10} size="small"><Icon name="plus"></Icon></Button>
            </Grid.Column>
            <Grid.Column width={3}>
              <Input
                label={{ basic: true, content: '€' }}
                disabled
                fluid
                labelPosition='right'
                placeholder=''
                value={(nbEntrancesIndividualNLG * Globals.TarifIndividuelNLG)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={8}>
              Entrée famille (max. 5 pers.) <b style={{ whiteSpace: 'nowrap'}}>Résident Noisy-Le-Grand *</b>
              { nbEntrancesFamilyNLG > 1 && (
                <Message size="mini" color="orange" negative>
                  <Message.Header>Attention</Message.Header>
                  <p>Vous avez sélectionné {nbEntrancesFamilyNLG} entrées famille, soit l'équivalent de {nbEntrancesFamilyNLG * 5} entrées individuelles, assurez-vous que ce soit bien ce que vous désiriez.</p>
                  </Message>
              )}
            </Grid.Column>
            <Grid.Column width={5}>
              <Button onTouchEnd={(e:any) => { e.preventDefault(); setNbEntrancesFamilyNLG(nbEntrancesFamilyNLG - 1); }} onClick={() => setNbEntrancesFamilyNLG(nbEntrancesFamilyNLG - 1)} disabled={nbEntrancesFamilyNLG <= 0} size="small"><Icon name="minus"></Icon></Button>
              <Dropdown
                selection
                compact
                key="familyEntrancesNLG"
                options={nbEntrancesFamilyOptions}
                value={nbEntrancesFamilyNLG}
                onChange={(ev, { value }) => { setNbEntrancesFamilyNLG((value as number)); }}
              />
              &nbsp;
            <Button onTouchEnd={(e:any) => { e.preventDefault(); setNbEntrancesFamilyNLG(nbEntrancesFamilyNLG + 1); }}  onClick={() => setNbEntrancesFamilyNLG(nbEntrancesFamilyNLG + 1)} disabled={nbEntrancesFamilyNLG >= 5} size="small"><Icon name="plus"></Icon></Button>
            </Grid.Column>
            <Grid.Column width={3}>
              <Input
                label={{ basic: true, content: '€' }}
                disabled
                fluid
                labelPosition='right'
                placeholder=''
                value={(nbEntrancesFamilyNLG * Globals.TarifFamilleNLG)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={8}>Entrée individuelle Hors Noisy-Le-Grand</Grid.Column>
            <Grid.Column width={5}>
              <Button onClick={() => setNbEntrancesIndividualHNLG(nbEntrancesIndividualHNLG - 1)} disabled={nbEntrancesIndividualHNLG <= 0} size="small"><Icon name="minus"></Icon></Button>
              <Dropdown
                selection
                compact
                key="individualEntrancesHNLG"
                options={nbEntrancesIndividualOptions}
                value={nbEntrancesIndividualHNLG}
                onChange={(ev, { value }) => { setNbEntrancesIndividualHNLG(parseInt((value || 0).toString())); }} />
            &nbsp;
            <Button onClick={() => setNbEntrancesIndividualHNLG(nbEntrancesIndividualHNLG + 1)} disabled={nbEntrancesIndividualHNLG >= 10} size="small"><Icon name="plus"></Icon></Button>
            </Grid.Column>
            <Grid.Column width={3}>
              <Input
                label={{ basic: true, content: '€' }}
                disabled
                fluid
                labelPosition='right'
                placeholder=''
                value={(nbEntrancesIndividualHNLG * Globals.TarifIndividuelHNLG)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={8}>
              Entrée famille (max. 5 pers.) Hors Noisy-Le-Grand
              { nbEntrancesFamilyHNLG > 1 && (
                <Message size="mini" color="orange" negative>
                  <Message.Header>Attention</Message.Header>
                  <p>Vous avez sélectionné {nbEntrancesFamilyHNLG} entrées famille, soit l'équivalent de {nbEntrancesFamilyHNLG * 5} entrées individuelles, assurez-vous que ce soit bien ce que vous désiriez.</p>
                  </Message>
              )}
            </Grid.Column>
            <Grid.Column width={5}>
              <Button onClick={() => setNbEntrancesFamilyHNLG(nbEntrancesFamilyHNLG - 1)} disabled={nbEntrancesFamilyHNLG <= 0} size="small"><Icon name="minus"></Icon></Button>
              <Dropdown
                selection
                compact
                key="familyEntrancesHNLG"
                options={nbEntrancesFamilyOptions}
                value={nbEntrancesFamilyHNLG}
                onChange={(ev, { value }) => { setNbEntrancesFamilyHNLG(value as number) }}
              />
              &nbsp;
            <Button onClick={() => setNbEntrancesFamilyHNLG(nbEntrancesFamilyHNLG + 1)} disabled={nbEntrancesFamilyHNLG >= 5} size="small"><Icon name="plus"></Icon></Button>
            </Grid.Column>
            <Grid.Column width={3}>
              <Input
                label={{ basic: true, content: '€' }}
                disabled
                fluid
                labelPosition='right'
                placeholder=''
                value={(nbEntrancesFamilyHNLG * Globals.TarifFamilleHNLG)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={8}>Entrée gratuite enfant moins de 2 ans</Grid.Column>
            <Grid.Column width={5}>
              <Button onClick={() => setNbEntrancesFree(nbEntrancesFree - 1)} disabled={nbEntrancesFree <= 0} size="small"><Icon name="minus"></Icon></Button>
              <Dropdown
                selection
                compact
                key="nbEntrancesFree"
                options={nbEntrancesFreeOptions}
                value={nbEntrancesFree}
                onChange={(ev, { value }) => { setNbEntrancesFree(value as number) }}
              />
              &nbsp;
            <Button onClick={() => setNbEntrancesFree(nbEntrancesFree + 1)} disabled={nbEntrancesFree >= 10} size="small"><Icon name="plus"></Icon></Button>
            </Grid.Column>
            <Grid.Column width={3}>
              <Input
                label={{ basic: true, content: '€' }}
                disabled
                fluid
                labelPosition='right'
                placeholder=''
                value={(nbEntrancesFree * 0)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        { (nbEntrancesFamilyNLG + nbEntrancesFamilyHNLG + nbEntrancesIndividualNLG + nbEntrancesIndividualHNLG === 0) && (
          <Message size="mini" negative>Vous devez sélectionner au moins une entrée (hors entrée gratuite)</Message>
        )}
        <Message size="mini"><b>* Un justificatif de domicile pourra vous être demandé pour le tarif résident Noisy-Le-Grand </b></Message>
        <Grid>
          <Grid.Row columns="2">
            <Grid.Column><b>Montant total: {totalAmount} &euro;</b></Grid.Column>
            <Grid.Column textAlign="right">
              <Button size='medium' color='green' onClick={() => { setStep(2); executeScroll() }} icon labelPosition="right" disabled={!(selectedDate && selectedTime && (nbEntrancesFamilyNLG + nbEntrancesFamilyHNLG + nbEntrancesIndividualNLG + nbEntrancesIndividualHNLG > 0))}><Icon name="user"></Icon> Etape suivante</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        </React.Fragment>)
      }
      { step === 2 && (<>
          <Form.Group widths="equal">
            <Form.Field required>
              <label>Nom</label>
              <Input value={lastName} key="lastName" onChange={(ev, { value }) => { setLastName(value); }} />
            </Form.Field>
            <Form.Field required>
              <label>Prénom</label>
              <Input value={firstName} key="firstName" onChange={(ev, { value }) => { setFirstName(value); }} />
            </Form.Field>
            <Form.Field required>
              <label>Code Postal</label>
              <Input value={zipCode} key="zipCode" maxLength="5"
                onChange={(ev, { value }) => { 
                  setZipCode(value); }} 
                onBlur={() => {
                  setDisplayZipCodeError((!zipCode || zipCode.length < 5));
                }} 
                />
              { displayZipCodeError && (
                <Message size="mini" negative>Le code postal n'est pas valide (doit être composé de 5 caractères numériques).</Message>
              )}
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field required>
              <label>Adresse email</label>
              <Input value={email} key="email"
                onChange={(ev, { value }) => { setEmail(value.trim()); }} 
                onBlur={() => {
                  setDisplayEmailError(!emailIsValid);
                }} />
              { displayEmailError && (
                <Message size="mini" negative>Email invalide</Message>
              )}
            </Form.Field>
            <Form.Field required>
              <label>Vérification adresse email</label>
              <Input value={verificationEmail} key="emailVerification" 
                onChange={(ev, { value }) => { setVerificationEmail(value); }}
                onBlur={() => {
                  setDisplayVerificationEmailError(email !== verificationEmail);
                }} />
              { displayVerificationEmailError && (
                <Message size="mini" negative>L'email de confirmation doit être le même que l'email.</Message>
              )}              
            </Form.Field>
            <Form.Field>
              <label>Téléphone (facultatif)</label>
              <Input value={phoneNumber} key="phoneNumber" onChange={(ev, { value }) => { setPhoneNumber(value); }} />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
          <Form.Field required>
              <label>Première visite</label>
              <Checkbox defaultChecked={isFirstVisit} label="Décochez si ce n'est pas votre première visite à la ferme" onChange={(ev, { checked }) => { setIsFirstVisit(checked !== undefined ? checked : true)}}></Checkbox>
            </Form.Field>
            <Form.Field>
              <label>Comment nous avez-vous connu ?</label>
              <Select options={referrerOptions} key="referrer" onChange={(ev, { value }) => { setReferrer(value as string); }}>
              </Select>
            </Form.Field>
            <Form.Field>
              { referrer === "Autre" && (
                <>
                <label>Pouvez-vous nous donner plus de détails ?</label>
                <Input value={otherReferrer} key="otherreferrer" maxLength="100" onChange={(ev, { value }) => { setOtherReferrer(value); }} />
                </>
              )}
            </Form.Field>
          </Form.Group>
          <p>Veuillez bien vérifier votre adresse email, celle-ci est importante car votre attestation de réservation et votre reçu de paiement y seront envoyés.</p>
          <Grid>
            <Grid.Row columns="2">
              <Grid.Column>                
                <Button size='small' icon labelPosition='left' onClick={() => { setStep(1); executeScroll() }}><Icon name='arrow left' /> Etape précédente</Button>
              </Grid.Column>
              <Grid.Column textAlign="right">
                <Button size='medium' color='green' icon labelPosition='right' onClick={() => { setStep(3); executeScroll(); } } disabled={step2IsValid === false}><Icon name='payment' /> Etape suivante</Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </>
      )}
      { step === 3 && (
        <>
          <Table celled striped unstackable>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell colSpan='3'>Vos billets pour la visite du <b>{visitDayOptions && visitDayOptions.filter(d => d.value === selectedDate)[0].text} à {visitHourOptions && visitHourOptions.filter(h => h.value === selectedTime)[0].text}</b></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              { nbEntrancesIndividualNLG > 0 && (
              <Table.Row>
                <Table.Cell>Entrée individuelle Noisy-Le-Grand</Table.Cell>
                <Table.Cell collapsing textAlign="center">x {nbEntrancesIndividualNLG}</Table.Cell>
                <Table.Cell collapsing textAlign='right'>{nbEntrancesIndividualNLG * Globals.TarifIndividuelNLG} &euro;</Table.Cell>
              </Table.Row>
              )}
              { nbEntrancesFamilyNLG > 0 && (
              <Table.Row>
                <Table.Cell>Entrée Famille (max 5 p.) Noisy-Le-Grand</Table.Cell>
                <Table.Cell collapsing textAlign="center">x {nbEntrancesFamilyNLG}</Table.Cell>
                <Table.Cell collapsing textAlign='right'>{nbEntrancesFamilyNLG * Globals.TarifFamilleNLG} &euro;</Table.Cell>
              </Table.Row>
              )}
              { nbEntrancesIndividualHNLG > 0 && (
              <Table.Row>
                <Table.Cell>Entrée individuelle Hors Noisy-Le-Grand</Table.Cell>
                <Table.Cell collapsing textAlign="center">x {nbEntrancesIndividualHNLG}</Table.Cell>
                <Table.Cell collapsing textAlign='right'>{nbEntrancesIndividualHNLG * Globals.TarifIndividuelHNLG} &euro;
             </Table.Cell>
              </Table.Row>
              )}
              { nbEntrancesFamilyHNLG > 0 && (
              <Table.Row>
                <Table.Cell>Entrée Famille (max 5 p.) Hors Noisy-Le-Grand</Table.Cell>
                <Table.Cell collapsing textAlign="center">x {nbEntrancesFamilyHNLG}</Table.Cell>
                <Table.Cell collapsing textAlign='right'>
                  {nbEntrancesFamilyHNLG * Globals.TarifFamilleHNLG} &euro;
             </Table.Cell>
              </Table.Row>
              )}
              { nbEntrancesFree > 0 && (
              <Table.Row>
                <Table.Cell>Entrée gratuite enfant moins de 2 ans</Table.Cell>
                <Table.Cell collapsing textAlign="center">x {nbEntrancesFree}</Table.Cell>
                <Table.Cell collapsing textAlign="right">0 &euro;</Table.Cell>
              </Table.Row>
              )}
              <Table.Row>
                <Table.Cell><i>Estimation nombre de personnes max.</i></Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell collapsing textAlign="center"><i>{nbEntrancesIndividualNLG + nbEntrancesIndividualHNLG + ((nbEntrancesFamilyNLG + nbEntrancesFamilyHNLG) * 5) + nbEntrancesFree}</i></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell><b>Total commande</b></Table.Cell>
                <Table.Cell></Table.Cell>
                <Table.Cell collapsing textAlign="right"><b>{totalAmount} &euro;</b></Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <Segment>
              <p><b><a href="https://www.fermerainbow.com/wp-content/app/docs/Conditions générales de vente -Prestations visite de la ferme.pdf" target="_blank" rel="noopener noreferrer" title="Consulter les conditions de vente">Consulter les CGV</a></b>.</p>
              <Checkbox
                label = 'En cochant cette case, je reconnais avoir pris connaissance et accepté les conditions générales de vente.'
                onChange={() => setValidatedCGV(!validatedCGV) }
                checked={validatedCGV}
                />
                <p>En cliquant sur "Procéder au paiement", vous serez redirigé vers le site de paiement sécurisé en ligne afin de finaliser votre achat.</p>
            </Segment>
          <Grid>
            <Grid.Row columns="2">
              <Grid.Column>
                <Button size='small' icon labelPosition='left' onClick={() => { setStep(2); executeScroll(); }} disabled={proceedingToPayment}><Icon name='arrow left' /> Etape précédente</Button>
              </Grid.Column>
              <Grid.Column textAlign="right">
                <Button size="medium" color='green' icon labelPosition='right' loading={proceedingToPayment} disabled={(!validatedCGV || proceedingToPayment)} onClick={proceedToPayment}><Icon name='credit card' /> Procéder au paiement</Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          { proceedingToPayment && (
            <Segment textAlign='center'>
                <Loader active inline size='small' />
                Veuillez patienter, vous allez être redirigé sur le site de paiement Stripe...
            </Segment>) 
          }
        </>
      )}
      { step === 4 && (
        <React.Fragment>
          <p>Votre numéro de réservation est <b>{bookingId}</b>.<br/>Vous allez recevoir un email récapitulatif avec l'attestation de réservation de la part de <b>reservations@fermerainbow.com</b> à présenter à l'accueil lors de votre visite, ainsi qu'un deuxième avec votre reçu de paiement de la part de <b>support@stripe.com</b>. Vérifiez-bien que votre boite de messagerie ne les a pas bloqués.</p>
          <p style={{textAlign: "center"}}><img src={`/api/qrcode/${bookingId}`} alt="" width="300" height="300" /></p>
          <p>Nous vous rappelons que pour des raisons d'organisation des groupes pour les visites, il vous faudra vous présenter au plus tard entre 5 et 10mn avant le créneau de votre réservation.</p>
          <p className="noprint">Vous pouvez sauvegarder cette page, celle-ci pourra servir d'attestation en cas d'email non reçu.</p>
          <p className="noprint"><Button onClick={() => { document.location.assign('/') }} color="green">Retourner à l'accueil du site</Button></p>
        </React.Fragment>
      )}
      { step === 5 && (
        <React.Fragment>
          <p>Vous avez annulé la commande ou un problème est survenu.</p>
          <p>Si vous n'avez pas annulé volontairement, nous vous conseillons d'attendre quelques minutes pour vérifier que vous ne recevez pas de confirmation pour éviter une double réservation.</p>
          <p><Button onClick={() => { document.location.assign('/') }} color="green" exact>Retourner à l'accueil du site</Button> <Button onClick={() => { document.location.assign('/reserver-votre-visite/') }} color="green" exact>Retenter la réservation</Button></p>
          </React.Fragment>
      )}
      <Message negative={true} hidden={!errorMessage}>{errorMessage}</Message>
      </Form>
    </Container>
  );
}

export default ReservationVisite;
